document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".search_custom_trigger");
  const closeBtn = document.querySelector('.header__search-close[aria-label="Close search popup"]');
  const headerSearch = document.querySelector(".header__search");

  if (triggers.length && headerSearch) {
    triggers.forEach(trigger => {
      trigger.addEventListener("click", function () {
        headerSearch.style.display = "flex";
      });
    });
  }

  if (closeBtn && headerSearch) {
    closeBtn.addEventListener("click", function () {
      headerSearch.style.removeProperty("display");
    });
  }
});


// Zipchat — shadow DOM style overrides

document.addEventListener('DOMContentLoaded', () => {
  let applied = false;

  const applyStyles = () => {
    if (applied) return true;

    const host = document.querySelector('#zipchat-shadow-host');
    if (!host || !host.shadowRoot) return false;

    // Flag the host so shadow-scoped selectors can react to the
    // light-DOM body class without crossing the shadow boundary.
    if (document.body.classList.contains('product-template')) {
      host.setAttribute('data-product', '');
    }

    const sheet = new CSSStyleSheet();
    sheet.replaceSync(`
      @media screen and (max-width: 767px) {
        #widget-chat-container {
          left: unset !important;
          transform: none !important;
          bottom: 20px !important;
          right: 25px !important;
          width:55% !important;
        }

        div#type-bar {
          padding-block: 8px !important;
        }

        :host([data-product]) #widget-chat-container {
          bottom: 20px !important;
          right: 0px !important;
        }
      }

      @media screen and (min-width: 768px) {
        input#type-bar-input {
          max-width: 149px !important;
        }

        div#type-bar-wrapper {
          max-width: 250px !important;
        }

        div#type-bar {
          padding-block: 8px !important;
        }
      }
    `);

    host.shadowRoot.adoptedStyleSheets = [
      ...host.shadowRoot.adoptedStyleSheets,
      sheet
    ];

    applied = true;
    return true;
  };

  // Apply immediately if the widget is already mounted...
  if (applyStyles()) return;

  // ...otherwise wait for it to appear.
  const observer = new MutationObserver(() => {
    if (applyStyles()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});